"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OptionsIconButton = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var OptionsIconButton = _styledComponents["default"].button.withConfig({
  displayName: "styled__OptionsIconButton",
  componentId: "sc-1v8u75x-0"
})(["outline:none;border:none;padding:0;background:transparent;margin-top:6px;padding:0 12px;cursor:pointer;"]);

exports.OptionsIconButton = OptionsIconButton;